import { replacePathParams } from '@/api/utils';
import { PersonalizationSettingsChannelType } from '@/api/apis/communication/personalization';

export const communicationApiPaths = {
  notificationHub: '/communicationservice/notificationhub',
  settings: '/communicationservice/settings',
  personalization: '/communicationservice/personalization',
  togglePersonalizationCategoryChannel:
    '/communicationservice/personalization/category/:categoryName/channel/:channelType',
  togglePersonalizationEventChannel:
    '/communicationservice/personalization/notification/:notificationName/channel/:channelType',
} as const;

export const getCommunicationApiUrl = {
  notificationHub: () => communicationApiPaths.notificationHub,
  settings: () => communicationApiPaths.settings,
  personalization: () => communicationApiPaths.personalization,
  togglePersonalizationCategoryChannel: (categoryName: string, channelType: PersonalizationSettingsChannelType) =>
    replacePathParams(communicationApiPaths.togglePersonalizationCategoryChannel, {
      categoryName,
      channelType,
    }),
  togglePersonalizationEventChannel: (eventName: string, channelType: PersonalizationSettingsChannelType) =>
    replacePathParams(communicationApiPaths.togglePersonalizationEventChannel, {
      notificationName: eventName,
      channelType,
    }),
};
